import React from 'react';
import '../css/dynamicContactCard.css';
import RoundButton from '../../../button/round-button/ts/roundButton';

interface DynamicContactCardProps {
  icon?: string;
  iconAlt?: string;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick?: () => void;
  className?: string;
}

const DynamicContactCard: React.FC<DynamicContactCardProps> = ({
  icon,
  iconAlt,
  title,
  description,
  buttonText,
  onButtonClick,
  className
}) => {
  return (
    <div className={`scl--web-component-dynamic-contact-card ${className || ''}`}>
      <div className="scl--web-component-dynamic-contact-card-icon">
        <img src={icon} alt={iconAlt} />
      </div>
      <div className="scl--web-component-dynamic-contact-card-content">
        <h3 className="scl--web-component-dynamic-contact-card-title">{title}</h3>
        <p className="scl--web-component-dynamic-contact-card-description">{description}</p>
        <RoundButton
          text={buttonText}
          onClick={onButtonClick}
          showIcon={false}
          className="scl--web-component-dynamic-contact-card-button"
        />
      </div>
    </div>
  );
};

export default DynamicContactCard;
